import React from 'react';
import { useI18n } from '../i18n/I18nContext';

const contactEmail = 'enquiry@cinemazone.au';

export const Footer: React.FC = () => {
  const { t } = useI18n();

  return (
    <footer className="mt-2 bg-black">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-stone-300">
          <p>© 2026 Appvanz Pty Ltd. ABN: 34668403478</p>
          <p className="mt-1">
            {t('emailLabel')}{' '}
            <a href={`mailto:${contactEmail}`} className="text-[#ffd460] hover:text-[#ffc83d]">
              {contactEmail}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
